export const getHTTPProtocol = (
	resourceTimings: PerformanceEntry[],
	isDomainSharingInSpaBootstrapScripts: boolean,
) => {
	if (isDomainSharingInSpaBootstrapScripts) {
		// New behavior: skip cache hits and differentiate unsupported vs unknown
		let hasScriptEntries = false;
		let hasNextHopProtocolProperty = false;

		for (const entry of resourceTimings as PerformanceResourceTiming[]) {
			if (entry.initiatorType !== 'script') {
				continue;
			}

			hasScriptEntries = true;

			// Skip cache hits — cached resources have transferSize === 0 and
			// the browser reports nextHopProtocol as "" since no network hop occurred.
			if (entry.transferSize === 0) {
				continue;
			}

			if ('nextHopProtocol' in entry) {
				hasNextHopProtocolProperty = true;
				if (entry.nextHopProtocol) {
					return entry.nextHopProtocol;
				}
			}
		}

		if (!hasScriptEntries || !hasNextHopProtocolProperty) {
			// The browser does not support nextHopProtocol or there are no script entries
			return 'unsupported';
		}

		// All non-cached script entries had an empty nextHopProtocol
		return 'unknown';
	} else {
		// Old behavior: return the first nextHopProtocol found, or 'unknown'
		for (const entry of resourceTimings as PerformanceResourceTiming[]) {
			if (entry.initiatorType !== 'script') continue;
			// As of Feb 2021, `nextHopProtocol` is only supported by 73% of browsers
			// https://caniuse.com/mdn-api_performanceresourcetiming_nexthopprotocol
			if ((entry as any)?.nextHopProtocol) {
				return (entry as any).nextHopProtocol;
			}
		}
		return 'unknown';
	}
};
